<!-- =========================================================================================
    File Name: Recommend.vue
    Description: Price Optimization Recommendation
    ----------------------------------------------------------------------------------------
    Item Name: Appyvue - Bootstrap App with PY and VUE
    Author: @nand
========================================================================================== -->
<template>
  <div id="recommend" class="mt-base">
    <!-- <pre>{{unitSelected}}</pre> -->
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/4 lg:w-1/4 xl:w-1/4">
        <statistics-card-line
          icon="ShoppingCartIcon"
          :statistic="recommendData.stat.objective"
          :statisticTitle="'Objective ( '+recommendData.stock.length+ ' SKUs )'"
          :chartData="statChartData"
          color="warning"
          hideChart
          icon-right
          class="mb-base"
        ></statistics-card-line>
      </div>
      <div class="vx-col w-full md:w-1/4 lg:w-1/4 xl:w-1/4">
        <statistics-card-line
          icon="InfoIcon"
          :statistic="recommendData.stat.platformDiscount | numFormat('0 %')"
          statisticTitle="SKUs need discount"
          :chartData="statChartData"
          color="warning"
          hideChart
          icon-right
          class="mb-base"
        ></statistics-card-line>
      </div>
      <div class="vx-col w-full md:w-1/4 lg:w-1/4 xl:w-1/4">
        <statistics-card-line
          icon="PackageIcon"
          :statistic="recommendData.stat.recommends | numFormat('0 %')"
          statisticTitle="SKUs need Bundling"
          :chartData="statChartData"
          color="success"
          hideChart
          icon-right
          class="mb-base"
        ></statistics-card-line>
      </div>
      <div class="vx-col w-full md:w-1/4 lg:w-1/4 xl:w-1/4">
        <statistics-card-line
          icon="MessageSquareIcon"
          :statistic="recommendData.stat.promotions | numFormat('0 %')"
          statisticTitle="SKUs need promotions"
          :chartData="statChartData"
          color="warning"
          hideChart
          icon-right
          class="mb-base"
        ></statistics-card-line>
      </div>
    </div>
    <div class="vx-row">
      <!-- <pre>{{showStatsPanel}} -> {{unitSelected}}</pre> -->
      <div class="vx-col w-full mb-base" :class="showStatsPanel ? 'lg:w-2/3' : 'lg:w-full'">
        <vx-card title="List of SKUs available for the selected category">
          <vs-table pagination max-items="5" search :data="recommendData.stock" @selected="handleSelected">
            <template slot="thead">
              <vs-th></vs-th>
              <vs-th sort-key="sku_id">SKU Id</vs-th>
              <vs-th sort-key="short_description">SKU Desc</vs-th>
              <vs-th sort-key="recommended_discount_percent">Discount</vs-th>
              <vs-th sort-key="discount_sensitivity">Sensitivity</vs-th>
              <vs-th sort-key="bundle_flag">Bundle</vs-th>
              <vs-th sort-key="promotion_flag">Promote</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr
                :state="applyState(tr)"
                :data="tr"
                :key="indextr"
                v-for="(tr, indextr) in data"
              >
                <vs-td>{{ data[indextr].row ? data[indextr].row : (indextr+1) }}</vs-td>
                
                <vs-td :data="data[indextr].sku_id">{{ data[indextr].sku_id }}</vs-td>

                <vs-td :data="data[indextr].short_description">{{ data[indextr].short_description }}</vs-td>

                <vs-td :data="data[indextr].recommended_discount_percent">{{ (data[indextr].recommended_discount_percent) | numFormat('0.00 %') }}</vs-td>

                <vs-td :data="data[indextr].discount_sensitivity">{{ data[indextr].discount_sensitivity | numFormat('0.000') }}</vs-td>

                <vs-td :data="data[indextr].bundle_flag">
                  <span class="flex items-center px-2 py-1 rounded"><div class="h-3 w-3 rounded-full mr-2" :class="(data[indextr].bundle_flag === 1 ? 'bg-success' : '')"></div>{{data[indextr].bundle_flag === 1 ? 'Bundle' : ''}}</span>
                </vs-td>

                <vs-td :data="data[indextr].promotion_flag">
                  <span class="flex items-center px-2 py-1 rounded"><div class="h-3 w-3 rounded-full mr-2" :class="(data[indextr].promotion_flag === 1 ? 'bg-success' : '')"></div>{{data[indextr].promotion_flag === 1 ? 'Promote' : ''}}</span>
                </vs-td>

              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
      <div
        class="vx-col w-full mb-base"
        :class="showStatsPanel ? 'lg:w-1/3' : ''"
        v-show="showStatsPanel"
      >
        <vx-card
          title="SKU Level details"
          title-color="#fff"
          class="bg-primary-gradient"
        >
          <template slot="actions">
            <feather-icon icon="SettingsIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
          </template>
          <div slot="no-body" class="p-6">
            <div class="vx-col w-full">
              <vx-card :title="unitSelected && unitSelected.sku_id ? unitSelected.short_description : 'SKU desc here'"
              :subtitle="'Brand - ' + (unitSelected && unitSelected.brand ? unitSelected.brand : '-')">
                    <template slot="no-body">
                        <div class="p-8 clearfix">
                            <div>
                                <h1><strong> {{(unitSelected && unitSelected.new_price ? unitSelected.new_price : '-') | numFormat('$ 0,0')}}</strong></h1>
                                <small><span class="text-grey">Old Price - {{(unitSelected && unitSelected.last_price ? unitSelected.last_price : '-') | numFormat('$ 0,0')}}</span></small>
                            </div>
                            <div class="flex justify-between">
                                <span class="flex items-center px-2 py-1 rounded"><div class="h-3 w-3 rounded-full mr-2" :class="(unitSelected.bundle_flag === 1 ? 'bg-success' : 'bg-danger')"></div>{{unitSelected.bundle_flag === 1 ? 'Need Bundling' : 'No Bundling'}}</span>
                                <span class="flex items-center px-2 py-1 rounded"><div class="h-3 w-3 rounded-full mr-2" :class="(unitSelected.promotion_flag === 1 ? 'bg-success' : 'bg-danger')"></div>{{unitSelected.promotion_flag === 1 ? 'Need Promotion' : 'No Promotion'}}</span>
                            </div>
                        </div>
                    </template>
                </vx-card>
              <!-- <statistics-card-line
                :icon="unitSelected.new_price - unitSelected.old_price < 0 ? 'TrendingDownIcon' : 'TrendingUpIcon'"
                icon-right
                :statistic="'AED '+(unitSelected && unitSelected.new_price ? unitSelected.new_price : '-')"
                :statisticTitle="'Old Price ~ AED '+(unitSelected && unitSelected.old_price ? unitSelected.old_price : '-')"
                :chartData="chartData"
                color="success"
              ></statistics-card-line> -->
            </div>
            <div class="vx-col w-full" v-if="filteredStock.length > 0">
              <vx-card title="Top Similar styles" subtitle="">
                <div
                  v-for="(sku, index) in filteredStock"
                  :key="sku.sku_id"
                  :class="{'mt-4': index}"
                >
                  <div class="flex justify-between">
                    <div class="flex flex-col">
                      <span class="mb-1">{{ sku.desc }}</span>
                      <h1><strong> {{sku.new_price | numFormat('$ 0,0')}}</strong></h1>
                      <small><span class="text-grey">Old Price - {{sku.old_price | numFormat('$ 0,0') }}</span></small>
                    </div>
                    <!-- <div class="flex flex-col text-right">
                      <span class="flex -mr-1">
                        <span class="mr-1">{{ (unitSelected.new_price - sku.old_price) / 100 }}</span>
                        <feather-icon
                          :icon="unitSelected.new_price - sku.old_price < 0 ? 'ArrowDownIcon' : 'ArrowUpIcon'"
                          :svgClasses="[unitSelected.new_price - sku.old_price < 0 ? 'text-danger' : 'text-success'  ,'stroke-current h-4 w-4 mb-1 mr-1']"
                        ></feather-icon>
                      </span> 
                      <span class="text-grey">AED {{ sku.old_price }}</span>
                    </div> -->
                  </div>
                  <vs-divider />
                  <!-- <vs-progress :percent="browser.ratio"></vs-progress> -->
                </div>
              </vx-card>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import StatisticsCardLine from "@/app/shared/components/statistics-cards/StatisticsCardLine.vue";

import appConfig from "@/../appConfig.js";

const themeColors = appConfig.chart.colors;

export default {
  props: {
    artefact: { type: Object, required: true }
  },
  data() {
    return {
      statChartData: {},
      showStatsPanel: false,

      unitSelected: {},
      priceTrend: {
        series: [{
            name: 'Price Trend',
            data: []
        }],
        chartOptions: {
            grid: {
                show: false,
                padding: {
                    left: 0,
                    right: 0
                }
            },
            chart: {
                type: 'line',
                dropShadow: {
                    enabled: true,
                    top: 5,
                    left: 0,
                    blur: 4,
                    opacity: 0.10,
                },
                toolbar: {
                    show: false,
                },
                sparkline: {
                    enabled: true
                }
            },
            stroke: {
                width: 5,
                curve: 'smooth'
            },
            xaxis: {
                type: 'numeric',
            },
            colors: themeColors,
            fill: {
                type: 'gradient',
                gradient: {
                    shade: 'dark',
                    gradientToColors: themeColors,
                    shadeIntensity: 1,
                    type: 'horizontal',
                    opacityFrom: 1,
                    opacityTo: 1,
                    stops: [0, 75, 100, 100]
                },
            },
            markers: {
                size: 0,
                hover: {
                    size: 5
                }
            },
            tooltip: {
                x: { show: false }
            },
        }
      },
      tableList: [
        "vs-th: Component",
        "vs-tr: Component",
        "vs-td: Component",
        "thread: Slot",
        "tbody: Slot",
        "header: Slot"
      ],
      recommendData: {
        stat: {
          objective: "Maximize ROS",
          platformDiscount: 30,
          recommends: 0,
          promotions: 0
        },
        stock: []
      }
    };
  },
  watch: {},
  computed: {
    filteredStock() {
      return this.recommendData.stock.filter(
        item =>
          this.unitSelected.similar_skus &&
          this.unitSelected.similar_skus.includes(item.sku_id)
      );
    },
    chartData() {
      let chartData = {};
      this.priceTrend.series[0].data = [];
      Object.assign(chartData, this.priceTrend);
      if(this.unitSelected && this.unitSelected.trend) {
        for(let i = 0; i < this.unitSelected.trend.length; i++) {
          // chartData.series[0].data.push(Number(this.unitSelected.trend[i]));
        }
      }

      return chartData;
    }

  },
  methods: {
    buildRecommendData() {
      let selectedUnit = this.artefact.tags && this.artefact.tags.length > 1 ? this.artefact.tags[1].tag : "";
      let selectedUnitData = this.artefact.res.recommend.data.filter(item => item.product_category.toLowerCase() === selectedUnit.toLowerCase());
      let discountStocks = selectedUnitData.filter(item => (item.recommended_discount_percent > 0));
      let recommendedStocks = selectedUnitData.filter(item => (item.bundle_flag === 1));
      let promotionStocks = selectedUnitData.filter(item => (item.promotion_flag === 1));

      this.recommendData.stock = selectedUnitData;
      this.recommendData.stat.objective = "Maximize ROS";
      this.recommendData.stat.platformDiscount = discountStocks.length/selectedUnitData.length;
      this.recommendData.stat.recommends = recommendedStocks.length/selectedUnitData.length;
      this.recommendData.stat.promotions = promotionStocks.length/selectedUnitData.length;

    },
    handleSelected(tr) {
      this.unitSelected = this.unitSelected.sku_id === tr.sku_id ? {} : tr;
      this.showStatsPanel = this.unitSelected && this.unitSelected.sku_id;
    },
    applyState(tr) {
      return tr.sku_id === this.unitSelected.sku_id ? "primary" : "";
    },


  },
  mounted() {
    this.buildRecommendData();
  },
  components: {
    VueApexCharts,
    StatisticsCardLine
  }
};
</script>

<style lang="scss">
#recommend {
  .greet-user {
    position: relative;
    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}
</style>